module.exports = __webpack_public_path__ + "img/financial.91de3ed7.png";